import axiosInstance from '../common/instance';

import {
  ExternalManagerRequestTypes,
  ExternalManagerTypes
} from './types';

export const getAllExternalManagerService = async (params: BaseFilterParams)
  : Promise<APIPaginationResponse<ExternalManagerTypes[]>> => {
  const res = await axiosInstance.get('external-managers', { params });
  return res.data;
};

export const getExternalManagerbyIdService = async (id: number)
  : Promise<ExternalManagerTypes> => {
  const res = await axiosInstance.get(`external-managers/${id}`);
  return res.data.data;
};

export const createExternalManagerService = async (params: ExternalManagerRequestTypes)
  : Promise<{ id: number }> => {
  const res = await axiosInstance.post('external-managers', params);
  return res.data.data;
};

export const updateExternalManagerService = async (id: number, params: ExternalManagerRequestTypes)
  : Promise<{ id: number }> => {
  const res = await axiosInstance.put(`external-managers/${id}`, params);
  return res.data.data;
};

export const deleteExternalManagerService = async (params: { ids: number[] })
  : Promise<void> => {
  await axiosInstance.delete('external-managers', { data: params });
};
